import { Router } from '@angular/router';
import { AuthService } from './../../../../services/auth.service';
import {Component, OnInit, ViewChild} from '@angular/core';
import {KahpooReverseService} from "../../../../services/kahpooreverse.service";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {KahpooReverse} from "../../../../models/kahpooReverse.model";
import * as XLSX from "xlsx";
import Swal from "sweetalert2";
import {DatePipe} from "@angular/common";
import { environment } from '../../../../environments/environment';
import {OrangeService} from "../../../../services/orange.service";
import * as html2pdf from 'html2pdf.js'
import { WaveService } from '../../../../services/wave.service';
import { WavePayoutInfo } from '../../../../models/wavePayoutInfo.model';
import { PaypalService } from '../../../../services/paypal.service';
@Component({
  selector: 'app-reversement-encours',
  templateUrl: './reversement-encours.component.html',
  styleUrls: ['./reversement-encours.component.scss']
})
export class ReversementEncoursComponent implements OnInit {
  sumReverse = 0;
  reverses = [];
  sorted = 1;
  reversesTmp = [];
  reversemementSelected: KahpooReverse;
  transactionForm: FormGroup;
  @ViewChild('closebutton') closebutton;

  /*
 -----------------------------         for all page attribute    --------------------------------
 */
  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  tableSizes: any = [10, 15, 30, 50];
  search: any;
  seller = false;
  perPage = 10;
  userForm : FormGroup;
  url_photo;
  /*
  end for all page
   */

  /*
   -----------------------------          for all page methodes      -----------------------------
    */

  onTableDataChange(event: any) {
    this.page = event;
    this.loadReverses();
  }
  onTableSizeChange(event: any): void {
    this.tableSize = event.target.value;
    this.page = 1;
    this.loadReverses();
  }

  searchFilter($event: KeyboardEvent) {
    this.kahpooReverseService.getAllKahpooReversementEnCours().subscribe(rs=> {
      this.reverses = rs;
      this.reverses = this.reverses.filter(value =>
        value?.kahpooReverseID?.toUpperCase().includes(this.search.toUpperCase()) ||
        value?.kahpooReverseUniqueID?.toUpperCase().includes(this.search.toUpperCase()) ||
        value?.status?.toUpperCase().includes(this.search.toUpperCase()) ||
        value?.user.lastname?.toUpperCase().includes(this.search.toUpperCase()) ||
        value?.user?.firstname?.toUpperCase().includes(this.search.toUpperCase())  ||
        value.username?.toLowerCase().includes(this.search.toUpperCase()) ||
        value?.user?.email?.toUpperCase().includes(this.search.toUpperCase())||
        value?.user?.firstname?.toUpperCase().includes(this.search.split(" ")[0].toUpperCase()) &&
        value?.user?.firstname?.toUpperCase().includes(this.search.split(" ")[1].toUpperCase()) ||
        value?.user?.lastname?.toUpperCase().includes(this.search.split(" ")[0].toUpperCase()) &&
        value?.user.lastname?.toUpperCase().includes(this.search.split(" ")[1].toUpperCase())
      );
    }, (err) => {
     // console.log('-----> err', err);
    });
  }

  displayPerPage(value: any) {
    this.perPage = parseInt(value, 10);
   // console.log(this.tableSize);
  }
  /*
  end for all page
   */

  // 👧🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥--------------- file input
  url: any;
  msg!: string;
  test = false;
  image: any;
  constructor(private kahpooReverseService:KahpooReverseService, private fb: FormBuilder,private datePipe: DatePipe,
              private authService: AuthService, private orangeService: OrangeService, private router: Router,
              private waveService: WaveService, private paypalService : PaypalService) { }

  ngOnInit(): void {
    this.authService.isAuthenticated().subscribe(isAuthenticated => {
      this.loadReverses();
      this.transactionForm = this.fb.group({
        //transactionDoneBy: ['', [Validators.required, Validators.pattern(/[a-zA-Z]+/)]],
        transactionDoneBy: ['', [Validators.required, Validators.pattern('^[a-zA-Z ]*$')]],
        transactionNumber: ['', [Validators.required]],
        // transactionNumber: ['', [Validators.required, Validators.pattern('^[a-zA-Z0-9 ]+$')]],
        referenceTransaction: ['', Validators.required]
      });
    },error=>{
      this.router.navigate(['/login']);
    });
  }

  loadReverses() {
    this.kahpooReverseService.getAllKahpooReversementEnCours().subscribe(rs=> {
      // console.log("Liste des reversements en attente de paiement");
      // console.log(rs)
      this.reverses =rs;
      this.reversesTmp =rs;
      if(this.reverses != null) {
        this.reverses.forEach(value => {
          // value.endAt = this.dateFormatService.transformDateArray(value.endAt);
          this.sumReverse += value.amount;
        })
      }
      // console.log("Liste des reversements en attente de paiement");
      // console.log(rs)
    })
  }

  confirmReverse(reverse:any) {
    this.reversemementSelected = reverse;
    //console.log(reverse);
  }

  selectReverse(reverse: any) {
    this.reversemementSelected = reverse;
    this.url_photo = environment.url_photo + '' + reverse.referenceTransaction;
    //console.log(reverse);
  }

  confirmOrangeReverse(reverse:any) {
    // console.log("Reserversement")
    // console.log(reverse)
    Swal.fire({
      title: 'Reversement avec Orange Money',
      text: 'Voulez-vous vraiment payer ce reversement avec orange',
      showCancelButton: true,
      cancelButtonText: 'Non',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui'
    }).then((result) => {
      if (result.isConfirmed) {
        this.orangeService.getRetailerBalance().subscribe(rs => {
          // console.log("Montant");
          // console.log(rs);
          if (rs.value < reverse.amount) {
            Swal.fire({
              icon: 'error',
              position: 'top-end',
              // title: err.error.errorMessage,
              title: "Le montant du solde du compte orange est inférieur au montant à reverser. Solde : " + rs.value + " Frcs",
              showConfirmButton: false,
              timer: 3500
            })
          } else {
            const env = localStorage.getItem('env');
            if (env !== 'production') {
              // reverse.transactionDoneBy = 'Kahpoo';
	            // reverse.transactionNumber = 'Kahpoo';
              this.kahpooReverseService.validReversementTest(reverse).subscribe(rs => {
               // console.log(rs);
                Swal.fire({
                  icon: 'success',
                  position: 'top-end',
                  title: "Paiement effectué avec succés",
                  showConfirmButton: false,
                  timer: 3500
                })
                this.loadReverses();
                }, err => {
                // console.log("Erreur validation")
                // console.log(err)
                Swal.fire({
                  icon: 'error',
                  position: 'top-end',
                  title: err.error.detail,
                  showConfirmButton: false,
                  timer: 3500
                })
              });
            } else {
              this.kahpooReverseService.reversementByOrangeMoney(reverse.id).subscribe(rs => {
                  Swal.fire({
                    icon: 'success',
                    position: 'top-end',
                    title: "Paiement effectué avec succés",
                    showConfirmButton: false,
                    timer: 3500
                  });
                }, err => {
                  // console.log("Affichage de l'erreur");
                  // console.log(err);
                  Swal.fire({
                    icon: 'error',
                    position: 'top-end',
                    title: err.error.detail,
                    showConfirmButton: false,
                    timer: 3500
                  })
                }
              );
            }
          }
        });
      } else if (result.dismiss) {
        Swal.fire({
          icon: 'error',
          text: 'Paiement annulée',
        })
      }
    });
  }

  // Reversement avec Paypal
  confirmPaypalReverse(reverse:any) {
    // console.log("Reserversement")
    // console.log(reverse)
    Swal.fire({
      title: 'Reversement avec Paypal',
      text: 'Voulez-vous vraiment payer ce reversement avec Paypal',
      showCancelButton: true,
      cancelButtonText: 'Non',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui'
    }).then((result) => {
      if (result.isConfirmed) {
        this.paypalService.reversementWithPaypal(reverse.id).subscribe(rs => {
          // console.log("Reversement avec Paypal....");
          // console.log(rs);
          // console.log("End ......");
          Swal.fire({
            icon: 'success',
            position: 'top-end',
            title: "Paiement effectué avec succés",
            showConfirmButton: false,
            timer: 3500
          })
          this.loadReverses();
          }, error => {
          // console.log("Le reversement avec paypal à échouer");
          // console.log(error)
          Swal.fire({
            icon: 'error',
            position: 'top-end',
            title: error.error.errorMessage,
            showConfirmButton: false,
            timer: 3500
          })
        });
      } else if (result.dismiss) {
        Swal.fire({
          icon: 'error',
          text: 'Reversement annulée',
        })
      }
    });
  }

  // Reversement avec Wave
  confirmWaveReverse(reverse:any) {
    // console.log("Reserversement")
    // console.log(reverse)
    Swal.fire({
      title: 'Reversement avec Wave',
      text: 'Voulez-vous vraiment payer ce reversement avec wave',
      showCancelButton: true,
      cancelButtonText: 'Non',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui'
    }).then((result) => {
      if (result.isConfirmed) {
        this.waveService.getWaveRetailerBalance().subscribe(rs => {
          // console.log("Montant");
          // console.log(rs);
          if (rs.value < reverse.amount) {
            Swal.fire({
              icon: 'error',
              position: 'top-end',
              // title: err.error.errorMessage,
              title: "Le montant du solde du compte wave est inférieur au montant à reverser. Solde : " + rs.value + " Frcs",
              showConfirmButton: false,
              timer: 3500
            })
          } else {
            this.waveService.reversementByWaveDigitalMonney(reverse.id).subscribe(rs => {
              Swal.fire({
                icon: 'success',
                position: 'top-end',
                title: "Paiement effectué avec succés",
                showConfirmButton: false,
                timer: 3500
              })
              this.loadReverses();
              }, error => {
              // console.log("reversement effectué");
              // console.log(rs)
              Swal.fire({
                icon: 'error',
                position: 'top-end',
                title: error.error.errorMessage,
                showConfirmButton: false,
                timer: 3500
              })
            });
          }
        }, err => {
            Swal.fire({
              icon: 'error',
              position: 'top-end',
              title: err.error.errorMessage,
              showConfirmButton: false,
              timer: 3500
            });
          });
      } else if (result.dismiss) {
        Swal.fire({
          icon: 'error',
          text: 'Reversement annulée',
        })
      }
    });
  }

  // Permet d'exporter en format pdf
  exportToPdf(){
    var element = document.getElementById('to-pdf');
   // console.log(element)
    var opt = {
      margin:       1,
      filename:     'Détails du reversement.pdf',
      image:        { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2,useCORS: true },
      jsPDF:        { unit: 'in', format: 'letter', orientation: 'portrait' }
    };

    // New Promise-based usage:
    html2pdf(element, opt);
  }

  get transactionDoneBy() {
    return this.transactionForm.get('transactionDoneBy');
  }

  get transactionNumber() {
    return this.transactionForm.get('transactionNumber');
  }

  disablePayementButton = false;
  onSubmit() {
    this.reversemementSelected.transactionDoneBy = this.transactionForm.controls['transactionDoneBy'].value;
    this.reversemementSelected.transactionNumber = this.transactionForm.controls['transactionNumber'].value;
    this.reversemementSelected.referenceTransaction = this.url;
    this.disablePayementButton = true;
    // console.log(this.reversemementSelected);
    this.kahpooReverseService.validReversement(this.reversemementSelected).subscribe(rs => {
      Swal.fire({
        position: 'top-end',
        icon: 'success',
        title: 'Le reversement a été effectué avec succés',
        showConfirmButton: false,
        timer: 1500
      });
      this.close();
      this.loadReverses();
    })
  }

  selectFile(event: any, i: number) {
    let urlPath: any;
    // Angular 11, for stricter type
    const mimeType = event.target.files[0].type;
    //console.log(event.target.files);
    const sizeFile = event.target.files[0].size;
    if (!event.target.files[0] || event.target.files[0].length === 0) {
      this.msg = 'Selectionner une photo';
    }
    // console.log('size!!!!!');
    // console.log(sizeFile);
    if (sizeFile < 2000000) {
     // console.log(mimeType);

      if (mimeType === 'image/jpeg' || mimeType === 'image/jpg'  || mimeType === 'image/svg' || mimeType === 'image/svg+xml' || mimeType === 'image/png') {

        const reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = (_event) => {
          this.msg = '';
          this.url = reader.result;
        };
      } else {

        // this.msg = "Ce type de fichier n'est pas pris en compte.";
        const reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = (_event) => {
          this.msg = 'Ce type de fichier n\'est pas pris en compte.';
          this.url = reader.result;
          this.test = false;
        };
      }
    } else {
      // this.msg = "la taille de l'image est trop grande";
      const reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = (_event) => {
        this.msg = 'La taille de l\'image est trop grande';
        this.url = reader.result;
        this.image = this.url;
        this.test = false;
       // console.log( this.url);
      };
    }
  }

  exportexcel(fileName): void {
    /* table id is passed over here */
    let element = document.getElementById('excel-table');
    const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, fileName);

  }

  close() {
    this.closebutton.nativeElement.click();
  }

  confirmNullReverse(reverse: any) {
    reverse.transactionDoneBy = 'Kahpoo';
    reverse.transactionNumber = 'Kahpoo';

    this.kahpooReverseService.validReversement(reverse).subscribe(rs => {
      //console.log(rs);
      Swal.fire({
        position: 'top-end',
        icon: 'success',
        title: 'Le reversement a été validé avec succés"',
        showConfirmButton: false,
        timer: 1500
      });
      this.loadReverses();
    })
  }

  disableEndDate = true;
  displayError = false;
  //Récupération de la date de début
  getBeginDate(event:any){
    this.beginDate=event.target.value;
    if(this.beginDate){
      this.disableEndDate = false;
      if(this.beginDate > this.endDate){
        this.displayError = true;
      }else{
        this.displayError = false;
      }
    }else{
      this.disableEndDate = true;
    }
  }
  // Récupération de la date de fin
  getEndDate(event){
    this.endDate=event.target.value;
  }


  /*
  filtre par date
   */

  beginDate: string = null;
  endDate: string = null;

  filter() {
   // console.log(this.endDate)
    if (this.endDate == null || this.beginDate== null) {
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Veuillez choisir une date de début et une date de fin s\'il vous plaît',
        showConfirmButton: false,
        timer: 3500
      })
      return;
    }
    if (this.endDate!= null && this.beginDate!= null && this.beginDate < this.endDate) {
      const dateString = this.endDate;
      const date = new Date(dateString);
      date.setDate(date.getDate() + 1); // ajoute 1 jour à la date
      this.endDate = this.datePipe.transform(date,'yyyy-MM-dd');
      this.reverses = this.reversesTmp;
      this.reverses = this.reverses.filter((rev) => {
        let date = this.datePipe.transform(rev.createdAt, 'yyyy-MM-dd')
        return (date >= this.beginDate &&  date  <= this.endDate);
      });
    }
  }

  resetFilter() {
    this.loadReverses();
    this.beginDate = null;
    this.endDate = null;
  }

  trier(columnName: keyof KahpooReverse) {
    this.sorted = -this.sorted;
    this.reverses.sort((a, b) => a[columnName] > b[columnName] ? this.sorted : -this.sorted);
  }
}
